import React, { useState } from "react";
import { motion } from "framer-motion";
import ProjectCard from "../components/common/ProjectCard";
import projectsData from "../data/projects.json";
import useLang from "../hooks/useLang";

const Projects = () => {
  const { t, dir } = useLang();
  const [activeFilter, setActiveFilter] = useState("all");

  const filters = [
    { key: "all", label: t("projects.filters.all") },
    { key: "Web", label: t("projects.filters.web") },
    { key: "Mobile", label: t("projects.filters.mobile") },
    { key: "AI", label: t("projects.filters.ai") },
    { key: "SaaS", label: t("projects.filters.saas") },
    { key: "ERP", label: t("projects.filters.erp") },
  ];

  const hasCategories = projectsData.some((p) => p.category);

  const filtered =
    activeFilter === "all"
      ? projectsData
      : projectsData.filter((p) => p.category === activeFilter);

  return (
    <div dir={dir} className="font-inter">
      {/* Hero */}
      <section className="pt-28 pb-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="container-site text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="inline-block bg-accent/10 text-accent text-sm font-semibold px-4 py-1.5 rounded-full mb-5">
              {t("ourWork.badge")}
            </span>
            <h1 className="text-5xl font-bold text-gray-900 mb-5">{t("ourWork.title")}</h1>
            <p className="text-gray-500 text-xl max-w-2xl mx-auto">{t("ourWork.description")}</p>
          </motion.div>
        </div>
      </section>

      {/* Filter Tabs */}
      {hasCategories && (
      <section className="py-8 bg-white border-b border-gray-100">
        <div className="container-site">
          <div className="flex flex-wrap gap-2 justify-center">
            {filters.map((filter) => (
              <button
                key={filter.key}
                onClick={() => setActiveFilter(filter.key)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                  activeFilter === filter.key
                    ? "bg-primary text-white shadow-sm"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>
      </section>
      )}

      {/* Projects Grid */}
      <section className="py-16 bg-white">
        <div className="container-site">
          <motion.div
            layout
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7"
          >
            {filtered.map((project, i) => (
              <ProjectCard key={project.id} project={project} index={i} />
            ))}
          </motion.div>
          {filtered.length === 0 && (
            <div className="text-center py-20 text-gray-400">
              No projects found in this category.
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Projects;
